const getFirstLetter = (name: string) => (name.length > 0 ? `${name[0].toUpperCase()}.` : '');

const getTruncatedLastNames = (names: string[] = []): string => {
    if (names.length === 0) {
        return '';
    }
    if (names.length > 1) {
        return ` ${getFirstLetter(names[0])} ${getFirstLetter(names[names.length - 1])}`;
    }

    return ` ${getFirstLetter(names[names.length - 1])}`;
};

const truncateName = (name?: string): string => {
    if (!name) {
        return '';
    }

    const [firstName, ...restOfNames] = name.split(' ');
    const truncatedLastNames = getTruncatedLastNames(restOfNames);

    return `${firstName ?? ''}${truncatedLastNames}`;
};

export const getTruncatedNameWithSuffix = (value?: string, suffix = '') =>
    value ? `${truncateName(value)} ${suffix}` : '';

export default truncateName;
